(function() {
	'use strict';

	angular
		.module('qbePortal')
		.controller('QBPaymentSummary', QBPaymentSummary);
	QBPaymentSummary.$inject = [
		'$scope',
		'quoteModelFactory',
		'$filter',
		'$state',
		'MODULE_INFO',
		'labelService',
		'userInputRepository',
		'$window',
	];

	function QBPaymentSummary(
		$scope,
		quoteModelFactory,
		$filter,
		$state,
		MODULE_INFO,
		labelService,
		userInputRepository,
		$window
	) {
		var vm = this,
			quoteHasCoverType = false;

		vm.state = $state;
		vm.saveSuccess = null;
		var quoteModel = quoteModelFactory.create();

		vm.saveQuote = function() {
			if (validateMail()) {
				$scope.$root.$broadcast(
					'sidebar-save-quote',
					vm.yourEmailAddress
				);
			} else {
				vm.saveSuccess = false;
			}
		};

		vm.assignEmail = function() {
			$scope.$root.$broadcast('sidebar-assign-mail', vm.yourEmailAddress);
		};

		function validateMail() {
			if (
				vm.yourEmailAddress == '' ||
				vm.yourEmailAddress == null ||
				angular
					.element('div')
					.find('[label-key=yourEmailAddress]')
					.hasClass('ng-invalid-email')
			) {
				return false;
			} else {
				userInputRepository.update({
					email: vm.yourEmailAddress
				});
				return true;
			}
		}

		// Add print specific class to pages with payment summary
		if (
			window.location.href.indexOf('quote') > -1 ||
			window.location.href.indexOf('contact') > -1 ||
			window.location.href.indexOf('payment') > -1
		) {
			var $columns = $('.columns').get(0);
			$columns.classList.add('print-ready');
		}

		$scope.$on('save-quote-success', function() {
			vm.saveSuccess = true;
		});

		$scope.$on('quote-received', onNewQuoteReceived);

		$scope.$on('selected-quote-changed', function() {
			setSelectedQuoteModel();
		});

		$scope.$root.$on('update-payment-options', updatePaymentOptions);

		$scope.$root.$on('$stateChangeSuccess', function() {
			$scope.mobileUnmatch();
		});

		$scope.mobileUnmatch = function() {
			var $colMain = document.querySelector('.col--main');
			// var colMainPosTop = $colMain.getClientRects()[0].top;
			var $content = document.getElementById('content');
			var $floatingModule = document.querySelector('.floating-module');

			$colMain.style.removeProperty('margin-top');

			// Reset element position
			// colMainPosTop = $colMain.getClientRects()[0].top;

			// Remove sticky classes
			$content.classList.remove('sticky');
			if (!!$floatingModule) {
				$floatingModule.classList.remove('sticky-mobile');
			}
		};

		vm.paymentPanelButtonText = getPaymentButtonText();
		vm.displayPaymentButton = vm.paymentPanelButtonText != null;

		function getPaymentButtonText() {
			if (
				MODULE_INFO.paymentPanelButtonText &&
				MODULE_INFO.paymentPanelButtonText[$state.current.name]
			)
				return MODULE_INFO.paymentPanelButtonText[$state.current.name];

			return null;
		}

		function onNewQuoteReceived(event, resp) {
			setSelectedQuoteModel();
		}

		function setSelectedQuoteModel(frequency) {
			quoteModel = quoteModelFactory.create();

			if (quoteModel.email != '') {
				vm.yourEmailAddress = quoteModel.email;
			}

			if (quoteModel.selectedQuote) {
				quoteHasCoverType = true;
			}

			if (!frequency) frequency = 'annual';

			if (quoteHasCoverType) {
				vm.quoteModel = quoteModel.selectedQuote;
				refreshPrices(frequency);
			}
		}

		vm.paymentOptions = 'yearly';

		function updatePaymentOptions(event, paymentOptions) {
			var frequency;
			// Set payment option
			vm.paymentOptions = paymentOptions;

			if (quoteHasCoverType) {
				// Set frequency label
				if (paymentOptions === 'yearly') {
					frequency = 'annual';
					vm.frequencyLabel = 'per_annum';
				} else if (paymentOptions === 'monthly') {
					frequency = 'monthly';
					vm.frequencyLabel = 'per_month';
				} else if (paymentOptions === 'fortnightly') {
					frequency = 'fortnightly';
					vm.frequencyLabel = 'per_fortnight';
				}

				setSelectedQuoteModel(frequency);
				// refreshPrices(frequency) ;
			}
		}

		function refreshPrices(frequency) {
			// Set cover type
			vm.frequencyLabel = 'per_annum';

			vm.coverType = vm.quoteModel.getQuoteResult(frequency).coverType;

			//additional condition for home
			if (
				vm.coverType === 'building_and_contents' ||
				vm.coverType === 'building_only' ||
				vm.coverType === 'contents_only'
			) {
				vm.coverType = vm.quoteModel.getQuoteResult(frequency).offering;
			}

			// Set quote results
			vm.quoteResults = vm.quoteModel.getQuoteResult(frequency).response;

			// Set discounts
			vm.discounts = vm.quoteResults.quoteResult.discounts;

			// Filter discounts per mapping and amount is greater than zero
			if (vm.discounts) {
				vm.savings = [];
				angular.forEach(vm.discounts, function(index) {
					if (
						!vm.mapServiceValue(
							'paymentSummaryDiscounts',
							index.discountType
						) &&
						index.amount !== 0
					) {
						vm.savings.push({
							discountType: index.discountType,
							amount: index.amount
						});
					}
				});
			}

			// Apply gift card
			if (
				vm.quoteResults.isGiftCardApplied &&
				vm.quoteResults.isGiftCardApplied === true
			) {
				if (
					vm.mapServiceValue(
						'paymentSummaryGiftCards',
						vm.quoteResults.campaignCode
					)
				) {
					vm.savings.push({
						discountType: vm.mapServiceValue(
							'paymentSummaryGiftCards',
							vm.quoteResults.campaignCode
						)
					});
				}
			}

			// Set payment plan
			vm.paymentPlan = vm.quoteResults.paymentPlan;

			// If there are any payment installments
			if (vm.paymentPlan.installment) {
				vm.paymentInstallment = $filter('styledCurrency')(
					vm.paymentPlan.installment
				);
			}

			//set monthly values
			vm.quoteMonthly = vm.quoteModel.getMonthly();
			vm.monthlyQuoteAmount = $filter('styledCurrency')(
				vm.quoteMonthly.paymentPlan.installment
			);

			//downpayment
			vm.monthlyDownPayment = $filter('styledCurrency')(
				vm.quoteMonthly.paymentPlan.downPayment
			);

			//set fortnightly values
			vm.quoteFortnightly = vm.quoteModel.getFortnightly();
			vm.fortnightlyQuoteAmount = $filter('styledCurrency')(
				vm.quoteFortnightly.paymentPlan.installment
			);

			//down payment
			vm.fortnightlyDownPayment = $filter('styledCurrency')(
				vm.quoteFortnightly.paymentPlan.downPayment
			);

			// Set quote after discounts
			vm.quote = $filter('styledCurrency')(
				vm.quoteResults.quoteResult.totalPremium
			);

			// Set total monthly premium
			vm.premAfterDisc = $filter('styledCurrency')(
				vm.quoteMonthly.totalPremium
			);

			// Set reference documents
			vm.referenceDocuments = $filter('showFslOnlyNsw')(
				vm.quoteResults.referenceDocuments,
				vm.quoteResults.policyAddress.state
			);

			if (
				vm.referenceDocuments &&
				(vm.quoteResults.productCode === 'QPHHome' ||
					vm.quoteResults.productCode === 'QPHLandlord')
			) {
				angular.forEach(vm.referenceDocuments, function(
					documents,
					index
				) {
					if (documents.type === 'pds') {
						switch (vm.coverType) {
							case 'QPHStandardOffering':
								vm.referenceDocuments[
									index
								].name = labelService.getGlobalOptionLabel(
									'PDS',
									'standardPDSLabel'
								);
								break;

							case 'QPHPrestigeOffering':
								vm.referenceDocuments[
									index
								].name = labelService.getGlobalOptionLabel(
									'PDS',
									'prestigePDSLabel'
								);
								break;

							case 'QPHLandlordOffering':
								vm.referenceDocuments[
									index
								].name = labelService.getGlobalOptionLabel(
									'PDS',
									'landlordPDSLabel'
								);
								break;

							case 'QPHStrataContentsOffering':
								vm.referenceDocuments[
									index
								].name = labelService.getGlobalOptionLabel(
									'PDS',
									'strataPDSLabel'
								);
								break;
						}
					}
				});
			} else {
				angular.forEach(vm.referenceDocuments, function(
					documents,
					index
				) {
					if (documents.type === 'pds') {
						vm.referenceDocuments[
							index
						].name = labelService.getGlobalOptionLabel(
							'PDS',
							'sideBarlinkLabel'
						);
					}
				});
			}
		}

		vm.purchaseNow = function() {
			$scope.$root.$broadcast('form-submit', MODULE_INFO.mainFormName);
		};

		vm.printPage = function() {
			window.print();
		};

		vm.getPage = function() {
			return vm.state.current.name.split('.')[1];
		};

		vm.isPaymentOptionVisible = function(paymentOption) {
			if (vm.getPage() === 'payment') {
				//on payment page display baed on the user selection
				if (vm.paymentOptions === paymentOption) {
					return true;
				}
			} else {
				//if not on payment page display yearly and monthly
				if (paymentOption === 'yearly' || paymentOption === 'monthly') {
					return true;
				} else {
					return false;
				}
			}

			return false;
		};

		vm.lookupLabel = function(fieldName) {
			return labelService.getGlobalOptionLabel(
				'paymentSummary',
				fieldName
			);
		};

		vm.getDocument = function(gwDocument) {
			if (!gwDocument.url || !gwDocument.name) {
				return gwDocument;
			}
			if ($window.location.pathname.indexOf('/bike') !== -1) {
				if (gwDocument.name.indexOf('Insurance PDS') !== -1) {
					var bikePdsLink = vm.getGlobalOption('PDS', 'bikePdsLink');
					if (bikePdsLink) {
						gwDocument.url = bikePdsLink.label;
						return gwDocument;
					}				
				}				
			}
			else if ($window.location.pathname.indexOf('/caravan') !== -1) {
				if (gwDocument.name.indexOf('Insurance PDS') !== -1) {
					var caravanPdsLink = vm.getGlobalOption('PDS', 'caravanPdsLink');
					if (caravanPdsLink)	{
						gwDocument.url = caravanPdsLink.label;
						return gwDocument;
					}
				}
			}
			return gwDocument;
		}

		vm.mapServiceValue = function(serviceName, option) {
			option = option.trim();
			/** some service values come back untrimmed :) */
			return labelService.getGlobalOptionLabel(serviceName, option);
		};
		vm.getGlobalOption = function(key, option) {
			option = option.trim();
			return labelService.getGlobalOption(key, option);
		};

		setSelectedQuoteModel();
	}

	angular
		.module('qbePortal')
		.directive('qbPaymentSummary', function($window, $timeout) {
			return {
				restrict: 'E',
				templateUrl: '../ngviews/sections/common/payment-summary.html',
				controller: QBPaymentSummary,
				controllerAs: 'vm',
				link: function(scope, element) {
					// $timeout(function () {

					// Get qbPaymentSummary position and width
					var qbPaymentSummaryPosTop = element[0].getClientRects()[0]
						.top;
					var qbPaymentSummaryPosLeft = element[0].getClientRects()[0]
						.left;
					var qbPaymentSummaryWidth = element[0]
						.querySelector('div')
						.getClientRects()[0].width;

					// Floating module
					var $floatingModule = element[0].querySelector(
						'.floating-module'
					);
					var $floatingModuleContainer = element[0].querySelector(
						'.floating-module-container'
					);

					var $floatingModulePosTop = $floatingModule.getClientRects()[0]
						.top;
					// var breakPoint = $floatingModuleContainer.getClientRects()[0].bottom;

					// Cover details
					var $coverDetails = element[0].querySelector(
						'.expandcollapse'
					);
					var coverDetailsPosTop = $coverDetails.getClientRects()[0]
						.top;

					// Content element
					var $content = document.getElementById('content');

					var $colMain = document.querySelector('.col--main');
					var colMainHeight = $colMain.offsetHeight;
					var colMainPosTop = $colMain.getClientRects()[0].top;

					// Footer element
					var $footer = $('.footer').get(0);
					var footerHeight = $footer.offsetHeight;

					// For mobile
					enquire.register(DD.bp.get('0, s'), {
						match: function() {
							$content.classList.add('sticky');
							colMainPosTop = $colMain.getClientRects()[0].top;

							angular.element($window).off('scroll');

							// Set Initial Window position
							var windowPosition = $(window).scrollTop();
							angular.element($window).on('scroll', function() {
								// Set Floating module height and top position
								var $floatingModuleHeight =
									$floatingModule.clientHeight;
								var colMainPos = $colMain.getClientRects()[0]
									.top;

								// When scroll position is below quote panel
								if (colMainPos <= 0) {
									// Check scroll position
									var windowScroll = $(window).scrollTop();
									var floatingModuleHeight =
										'-' + $floatingModuleHeight + 'px';

									// Scrolling Down
									if (windowScroll > windowPosition) {
										$floatingModule.style.top = floatingModuleHeight;
									}
									// Scrolling Up
									else {
										$floatingModule.style.top = '0px';
										$floatingModule.classList.add(
											'sticky-mobile'
										);
									}

									windowPosition = windowScroll;
								}
								// Other scroll positions
								else {
									$floatingModule.classList.remove(
										'sticky-mobile'
									);
									$floatingModule.style.top = '0px';
								}
							});

							$timeout(function() {
								$colMain.style.marginTop =
									$floatingModule.offsetHeight - 10 + 'px';
							}, 1000);
						},
						unmatch: scope.mobileUnmatch
					});

					// For table and above
					enquire.register(DD.bp.get('m'), {
						match: function() {
							angular.element('.floating-module').css('top', '');

							// Update position and width on resize
							angular.element($window).on('resize', function() {
								if ($floatingModule.length > 0) {
									// Set element position and width
									qbPaymentSummaryPosLeft = element[0].getClientRects()[0]
										.left;
									qbPaymentSummaryWidth = element[0]
										.querySelector('div')
										.getClientRects()[0].width;

									colMainHeight = $colMain.offsetHeight;
									colMainPosTop = $colMain.getClientRects()[0]
										.top;

									coverDetailsPosTop = $coverDetails.getClientRects()[0]
										.top;
									// breakPoint = $floatingModuleContainer.getClientRects()[0].bottom;

									footerHeight = $footer.offsetHeight;
								}
							});

							angular.element($window).off('scroll');
							angular.element($window).on('scroll', function() {
								var $sidebarContainer = $('.floating-module');
								if ($sidebarContainer.length > 0) {
									// Floating save quote
									var $floatingSave =
										$('.floating-save-quote').length > 0
											? $('.floating-save-quote')[0]
													.offsetHeight * 4
											: 0;

									// When scroll position is below quote panel
									if (
										$window.pageYOffset >=
											coverDetailsPosTop &&
										$window.pageYOffset + footerHeight <
											$colMain.offsetHeight +
												colMainPosTop -
												$floatingSave
									) {
										// $floatingModule.style.width = qbPaymentSummaryWidth + 'px';
										// $floatingModule.style.left = qbPaymentSummaryPosLeft + 'px';
										$content.classList.remove(
											'sidebar-fixed'
										);
										$content.classList.add(
											'sidebar-follow'
										);

										// When scroll position is near the bottom of the page
									} else if (
										$window.pageYOffset + footerHeight >=
										$colMain.offsetHeight +
											colMainPosTop -
											$floatingSave
									) {
										// $floatingModule.style.left = '';
										$content.classList.remove(
											'sidebar-follow'
										);
										$content.classList.add('sidebar-fixed');

										// Other scroll positions
									} else {
										$floatingModule.removeAttribute(
											'style'
										);
										$content.classList.remove(
											'sidebar-follow'
										);
										$content.classList.remove(
											'sidebar-fixed'
										);
									}
								}
							});
						},
						unmatch: function() {
							if ($floatingModule.length > 0) {
								// Reset element position and width
								qbPaymentSummaryPosLeft = element[0].getClientRects()[0]
									.left;
								qbPaymentSummaryWidth = element[0]
									.querySelector('div')
									.getClientRects()[0].width;

								colMainHeight = $colMain.offsetHeight;
								colMainPosTop = $colMain.getClientRects()[0]
									.top;

								coverDetailsPosTop = $coverDetails.getClientRects()[0]
									.top;

								footerHeight = $footer.offsetHeight;

								// Remove sticky classes
								$floatingModule.removeAttribute('style');
								$content.classList.remove('sidebar-follow');
								$content.classList.remove('sidebar-fixed');
							}
						}
					});
				}
			};
		});
})();
